export enum BlackOperationName {
  OperationTyphoon = "Operation Typhoon",
  OperationZero = "Operation Zero",
  OperationX = "Operation X",
  OperationTitan = "Operation Titan",
  OperationAres = "Operation Ares",
  OperationArchangel = "Operation Archangel",
  OperationJuggernaut = "Operation Juggernaut",
  OperationRedDragon = "Operation Red Dragon",
  OperationK = "Operation K",
  OperationDeckard = "Operation Deckard",
  OperationTyrell = "Operation Tyrell",
  OperationWallace = "Operation Wallace",
  OperationShoulderOfOrion = "Operation Shoulder of Orion",
  OperationHyron = "Operation Hyron",
  OperationMorpheus = "Operation Morpheus",
  OperationIonStorm = "Operation Ion Storm",
  OperationAnnihilus = "Operation Annihilus",
  OperationUltron = "Operation Ultron",
  OperationCenturion = "Operation Centurion",
  OperationVindictus = "Operation Vindictus",
  OperationDaedalus = "Operation Daedalus",
}
